<style lang="less" scoped>
  .query-title-div {
    width: 110px !important;
  }
  .lang-width {
    width: 450px !important;
  }
  .margin-tb {
  height: 32px;
  margin-top: 4px;
}
.margin-tb-5{
  margin:5px 0;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">{{mainTitle}}</div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="listDetailFun('check')">查 看</button>
        <button class="common-bg-button" @click="listDetailFun('edit')">编 辑</button>
        <button class="common-bg-button" @click="toHandelRecord()">修改日志</button>
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true,isNormal)">
          搜 索
        </button>
        <button class="common-bg-button"
          @click="() => {
              showMultiQuerys = !showMultiQuerys;
            }"
          >高级筛选</button>
      </div>
            <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
                <p class="margin-tb-5 font-14">订单编号</p>
                <el-input
                  clearable
                  v-model="queryInfo.orderNo"
                  size="small"
                  placeholder="请输入订单编号"
                ></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电桩IMEI编号</p>
                <el-input
                  clearable
                  v-model="queryInfo.pileCode"
                  size="small"
                  placeholder="请输入充电桩IMEI编号"
                ></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">用户手机号</p>
                <el-input
                  clearable
                  v-model="queryInfo.custPhone"
                  size="small"
                  placeholder="请输入用户手机号"
                ></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">订单状态</p>
              <el-select
                v-model="queryInfo.orderStatus"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
                :disabled='!isNormal'
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.configVal"
                  :label="item.configName"
                  :value="item.configVal"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">结束方式</p>              
              <el-select
                v-model="queryInfo.chargeOverReason"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
              >
                <el-option label="拔枪" value="拔枪"></el-option>
                <el-option label="车主动断开" value="车主动断开"></el-option>
                <el-option label="指令" value="指令"></el-option>
                <el-option label="充满" value="充满"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="桩故障" value="桩故障"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电时间</p>
              <div class="flex-r">
              <el-date-picker
                  class="full-width"
                  size="small"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  v-model="chargeTime"
                  @change="pickdate(chargeTime)"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" v-if="!isNormal">
              <p class="margin-tb-5 font-14">异常处理状态</p>              
              <el-select
                v-model="queryInfo.processingStatus"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
              >
                <el-option label="已处理" value="Y"></el-option>
                <el-option label="未处理" value="N"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections=" (sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData(pagination, false,isNormal)"></ZD-pagination>
      </div>
    </div>
    <!-- 操作日志 -->
    <el-dialog title="操作日志" width="60%" :visible.sync="handelRecordObj.showDialog">
        <el-table
            class="el-table"
            :data="handelRecordObj.tableData"
            border
            max-height="600px"
            style="width: 100%;margin:20px auto"
            :header-cell-style="{background:'#FAFAFA',color:'#8F9BB3',fontSize: '14px',textAlign:'center', border: '1px solid #F0F0F0'}"
            >
              <el-table-column
                  prop="lastModifiedByName"
                  width="80"
                  label="操作人">
              </el-table-column>
              <el-table-column
                  prop="lastModifiedWhen"
                  width="160"
                  label="更改时间">
              </el-table-column>
              <el-table-column
                  prop="data"
                  min-width="300"
                  label="更改数据">
              </el-table-column>
        </el-table>
        <div class="list-pagination">
            <ZD-pagination :pagination="handelRecordObj.pagination" v-on:pageUpdate="toHandelRecord"></ZD-pagination>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      mainTitle:'正常充电订单',
      listColumns:pageConfig.listColumns,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      value1: true, //未使用
      showMultiQuerys:false,
      isNormal:true,
      chargeTime:[],
      statusList:[
        {
          configVal:'01',
          configName:'进行中',
        },
        {
          configVal:'02',
          configName:'待支付',
        },
        {
          configVal:'03',
          configName:'支付确认中',
        },
        {
          configVal:'04',
          configName:'异常',
        },
        {
          configVal:'05',
          configName:'已完成',
        },
        {
          configVal:'06',
          configName:'正常',
        },
      ],
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },

          // {
          //   id: 'charge',
          //   label: '充电记录',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     debugger
          //     this.$store.commit('setEditId', row.pileCode)
          //     // this.$router.push({ name: pageConfig.chargeDetailRouter });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.chargeDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'fault',
          //   label: '故障记录编辑',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.id)
          //     // this.$router.push({ name: pageConfig.faultDetail });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.faultDetail }).href,
          //       '_blank'
          //     )
          //   }
          // },
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
      handelRecordObj:{
        showDialog: false,
        tableData: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
        },
      },
    }
  },
  methods: {
      //查找站点名称 获取数据
    init() {
      console.log(this.$route.name);
      let name = this.$route.name;
      if(name == 'publicUnusualList'){
          this.mainTitle = '异常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '异常订单'
          this.listColumns = this.pageConfig.unusualListColumns
          this.queryInfo.orderStatus = '04'
          this.isNormal = false
        }else if(name == 'publicNormalList'){
          this.mainTitle = '正常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '正常订单'
          this.listColumns = this.pageConfig.listColumns
          this.queryInfo.orderStatus = '06'
          this.isNormal = true
        }
      this.getListData(this.pagination, true,this.isNormal)
    },
    // 获取表格数据
    getListData(pagination, reload = false,isNormal=true) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
        if(!isNormal){
          _.queryInfo.orderStatus = "04"
        }
      // if(_.queryInfo.orderStatus == '04'||_.queryInfo.orderStatus == '06'){
      //   _.queryInfo.orderStatus = '06'
      //   if(!isNormal){
      //     _.queryInfo.orderStatus = "04"
      //   }
      // }       
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.queryInfo.optType = '01';
      _.$H.post(_, _.$A.privatePile.findShareRecord, _.queryInfo).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    //改功能已删除
    getPileCodeArr(query) {
      let _ = this
      if (query.length >= 4) {
        //this.loading = true;
        var obj = {
          sort: '-pileCode',
          pileCode: query,
        }
        _.$H.post(_, _.$A.pile.findPileCodeList, obj).then((res) => {
          _.pileCodeArr = res.data.data
        })
      } else {
        this.pileCodeArr = []
      }
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
          this.$U.error('请选择需要操作的对象');
          return false;
      }
      if (selections.length > 1) {
          this.$U.error('只能选择一个操作的对象');
          return false;
      }
      return true;
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj)
    },
    //页面编辑方法
    listDetailFun(status) {
      let _ = this
      if(_.checkSelectOne(_.selections)){
        // this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
        this.$store.commit('setEditId', '');
        // if(status == 'edit'){
        //   this.$store.commit('setEditId', _.selections[0].custPileId);
        // }
        localStorage.removeItem('detail')
        localStorage.setItem('detail',JSON.stringify(this.selections[0]))
        localStorage.removeItem('status')
        localStorage.setItem('status',status)
      let routeUrl =  this.$router.resolve({
          name: this.isNormal?"publiPileDetail":'publipileUnusualDetail',
         
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    pickdate(time){
      let _ = this;
      // 拆分时间区间
      _.queryInfo.beginTime = time ? time[0]: ''
      _.queryInfo.endTime = time ? time[1]: ''
    },
    toHandelRecord(){
      let _ = this;
      let obj ={
        pageNum: _.handelRecordObj.pagination.current-1,
        pageSize:_.handelRecordObj.pagination.pageSize,
        webType:'pileOrder'
      } 
      _.$H.post(_, _.$A.digitization.webLog, obj).then(res => {
          _.handelRecordObj.tableData = res.data.data.content||[];
          _.handelRecordObj.pagination.total = res.data.data.totalElements||0;
          _.handelRecordObj.showDialog = true;
      })
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      if(isNormal){
        this.getListData(this.pagination, true,this.isNormal)
      }else{
        this.getListData(this.pagination, true,this.isNormal)
      }
    },
  },
  mounted() {
    this.init()
  },
  watch:{
    $route(newVal,oldVal){
      console.log("new_______",newVal);
      if(newVal.name == 'publicUnusualList'){
          this.isNormal = false;
          this.mainTitle = '异常充电订单'
          this.listColumns = this.pageConfig.unusualListColumns
          this.pageConfig.listBreadCrumb[2].name = '异常订单'
          this.getListData(this.pagination,true,false)
          this.queryInfo.orderStatus = '04'
        }else if(newVal.name == 'publicNormalList'){
          this.mainTitle = '正常充电订单'
          this.isNormal = true;
          this.listColumns = this.pageConfig.listColumns
          this.getListData(this.pagination,true,true)
          this.pageConfig.listBreadCrumb[2].name = '正常订单'
          this.queryInfo.orderStatus = '06'
        }
      this.getListData(this.pagination, true,this.isNormal)

    }
  }
}
</script>
